var alphaExp = /^[a-zA-Z]+$/;

function validation() {
    var firstName = document.getElementById('first-name').value;

    isEmpty(firstName, 'contact[First Name]', 'first-name');
}
function isString(value, lableName, errorElement) {
    if (!value.match(alphaExp)) {
        showError(lableName + ' must be string', errorElement);
    }
}
function showError(message, errorElement) {
    document.getElementById(errorElement + '-error').innerHTML = '';
    document.getElementById(errorElement + '-error').innerHTML = message, errorElement;
    return false;
}
